import { combineReducers } from 'redux';

import apiError from './apiError';
import ids from './ids';
import isLoading from './isLoading';
import page from './page';
import sort from './sort';

export default combineReducers({
  ids,
  sort,
  page,
  apiError,
  isLoading,
});
